import { render, staticRenderFns } from "./AboutIntro.vue?vue&type=template&id=07990472&scoped=true"
import script from "./AboutIntro.vue?vue&type=script&lang=js"
export * from "./AboutIntro.vue?vue&type=script&lang=js"
import style0 from "./AboutIntro.vue?vue&type=style&index=0&id=07990472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07990472",
  null
  
)

export default component.exports